import * as yup from "yup";

export const addUserSchema = yup.object({
  firstName: yup.string().required("First name is required"),
  lastName: yup.string().required("Last name is required"),
  dealerName: yup.string().required("Dealer name is required"),
  email: yup
    .string()
    .required("Email is required")
    .min(5, "Email must be at least 5 characters long")
    .email("Email is invalid"),
  country: yup.string().required("Country is required"),
  password: yup
    .string()
    .required("Password is required")
    .min(7, "Password must be at least 7 characters"),
  confirmPassword: yup
    .string()
    .required("Please confirm your password")
    .oneOf([yup.ref("password")], "Passwords do not match"),
});

export type AddUserFormData = yup.InferType<typeof addUserSchema>;

export const addUserDefaultValues: AddUserFormData = {
  firstName: "",
  lastName: "",
  dealerName: "",
  email: "",
  country: "",
  password: "",
  confirmPassword: "",
};

export const userCountries = [
  { label: "United States", value: "United States" },
  { label: "Canada", value: "Canada" },
  { label: "United Kingdom", value: "United Kingdom" },
  { label: "Australia", value: "Australia" },
  { label: "Germany", value: "Germany" },
  { label: "France", value: "France" },
  { label: "Italy", value: "Italy" },
  { label: "Spain", value: "Spain" },
  { label: "Netherlands", value: "Netherlands" },
  { label: "Belgium", value: "Belgium" },
  { label: "Switzerland", value: "Switzerland" },
  { label: "Austria", value: "Austria" },
  { label: "Sweden", value: "Sweden" },
  { label: "Norway", value: "Norway" },
  { label: "Denmark", value: "Denmark" },
  { label: "Finland", value: "Finland" },
  { label: "Japan", value: "Japan" },
  { label: "South Korea", value: "South Korea" },
  { label: "Singapore", value: "Singapore" },
  { label: "New Zealand", value: "New Zealand" },
];
